import React from "react"
import { utils } from '@/utils/index'

import styles from "./SearchHighlight.module.less"

const { getEscapeRegStr } = utils

interface SearchHighlightProps {
  productDesc: string
  searchText: string
}

/*
 * 分词
 * 如果含有英文或数字，则不拆词。否则按字符拆分。
 */
const highlightSplit = (searchText: string): string[] => {
  let splitTexts = []
  const reg = /a-zA-Z0-9-_\//g
  if (reg.test(searchText)) {
    splitTexts = [searchText]
  } else {
    splitTexts = searchText.split('')
  }
  return splitTexts
}

const SearchHighlight: React.FC<SearchHighlightProps> = ({ productDesc, searchText }) => {
  const splitTexts = highlightSplit(searchText || '')

  return (
    <>
      {
        // 没有搜索词时直接返回
        !searchText.length ? productDesc.split('\n').map((item, i) => {
          <span key={i}>{item}</span>
        }) :
        productDesc.split('\n').map((lineText, i) => {
          let lineTextArr = [lineText]
          let replaceResult = lineText

          splitTexts.forEach((item) => {
            replaceResult = replaceResult.replace(
              new RegExp(getEscapeRegStr(item), 'gi'),
              (match: string) => `$$$${match}$$$`,
            )
          })

          lineTextArr = replaceResult.split('$$$').filter((item) => item)

          return (
            <p key={i}>
              {lineTextArr.map((text, j) => {
                if (splitTexts.includes(text)) {
                  return <span className={styles['highlight']} key={j}>{text}</span>
                }
                return <span key={j}>{text}</span>
              })}
            </p>
          )
        })
      }
    </>
  ) 
}

export default SearchHighlight